import React from "react";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";

export default class CardAdminDepartmentGeneral extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={this.props.department ? this.props.department.name : ""}
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            onBlur={(e) => this.props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ name: e.target.value })}
            required={true}
            error={this.props.validationIssues.name ? true : false}
            helperText={
              this.props.validationIssues.name
                ? this.props.validationIssues.name
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={
              this.props.department && this.props.department.ordinal
                ? this.props.department.ordinal
                : ""
            }
            size="small"
            label="Ordinal"
            variant="standard"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({
                ordinal: /^[\d]+$/.test(e.target.value.trim())
                  ? parseInt(e.target.value)
                  : null,
              })
            }
            onChange={(e) => this.props.onChange({ ordinal: e.target.value })}
            required={false}
            error={this.props.validationIssues.ordinal ? true : false}
            helperText={
              this.props.validationIssues.ordinal
                ? this.props.validationIssues.ordinal
                : ""
            }
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
